import { render, staticRenderFns } from "./SingleProduct.vue?vue&type=template&id=85af4bfa"
import script from "./SingleProduct.vue?vue&type=script&lang=js"
export * from "./SingleProduct.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/wp-content/themes/svea/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('85af4bfa')) {
      api.createRecord('85af4bfa', component.options)
    } else {
      api.reload('85af4bfa', component.options)
    }
    module.hot.accept("./SingleProduct.vue?vue&type=template&id=85af4bfa", function () {
      api.rerender('85af4bfa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/scripts/vue/SingleProduct.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./scripts/vue/SingleProduct.vue
// module id = 93
// module chunks = 0